function isMobile(forceResolution) {

    var isMobile = false;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(navigator.userAgent) || (forceResolution == true && $(window).width() < 1000)) {
        isMobile = true;
    }

    return isMobile;
}

function isAppleMobile() {

    var isAppleMob = false;

    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        isAppleMob = true;
    }

    return isAppleMob; 
}

function isIpad() {
     
    var is_ipad = navigator.userAgent.toLowerCase().indexOf('ipad') > -1;
    
    return is_ipad;
}

function IsChrome() {

    var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;

    return isChrome;
}

function IsSafari() {

    var safari = navigator.userAgent.toLowerCase().indexOf('safari') > -1;
    var android = navigator.userAgent.toLowerCase().indexOf('android') > -1;

    if (safari && android) {
        safari = false;
    }

    return safari;
}

function IsAndroidSafari() {

    var safari = navigator.userAgent.toLowerCase().indexOf('safari') > -1;
    var android = navigator.userAgent.toLowerCase().indexOf('android') > -1;

    if (safari && android) {
        return true;
    }

    return false;
}

function IsAndroid() {

    var android = navigator.userAgent.toLowerCase().indexOf('android') > -1;

    if (android) {
        return true;
    }

    return false;
}

function IsFirefox() {

    var isFF = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    return isFF;
}

function compress(data) {
    var q = {}, ret = "";
    data.replace(/([^=&]+)=([^&]*)/g, function (m, key, value) {
        q[key] = (q[key] ? q[key] + "," : "") + value;
    });
    for (var key in q)
        ret = (ret ? ret + "&" : "") + key + "=" + q[key];
    return ret;
}

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function getQuery(url) {

    var q = (url.split('?')[1] || '').split('&'), o = {};
    for (var i = 0; i < q.length; i++) {
        var p = q[i].split('=');
        if (!!p[0]) o[unescape(p[0])] = unescape(p[1] || '');
    }
    return o;
}

function fnIsAppleMobile() {
    if (navigator && navigator.userAgent && navigator.userAgent != null) {
        var strUserAgent = navigator.userAgent.toLowerCase();
        var arrMatches = strUserAgent.match(/(iphone|ipod|ipad)/);
        if (arrMatches)
            return true;
    } // End if (navigator && navigator.userAgent) 

    return false;
} // End Function fnIsAppleMobile

function hexToRgb(hex) {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

function RenkKontrol(color) {
    var Return = (color[0] & 255) + (color[1] & 255) + (color[2] & 255) < 3 * 256 / 2;
    return Return;
}

/// <summary>Generate Loading Overlay</summary>
/// <param name="ParentElement">loading container element</param>
/// <param name="operation">show or hide</param>
function GenerateLocalLoading(ParentElement, operation) {
    var AddingOverlayHtml = '<div class="loading-overlay"><i class="button-loader"></i></div>';

    if (operation == "show") {
        if (ParentElement.find("loading-overlay").length == 0) {
            ParentElement.append(AddingOverlayHtml);
        }
    }
    else if (operation == "hide") {
        ParentElement.find(".loading-overlay").remove();
    }
}